import { c as _c } from "react/compiler-runtime";
import { TextField } from "@flat-ui";
import { AnalyticsFeedbackOptionList } from "@components/analytics/in-house/feedback/analytics-feedback-option-list";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import { DECISIONS_OPTIONS, OTHER_VALUE } from "@components/analytics/in-house/feedback/analytics-feedback-helper";

/**
 * Requires at least one selection, and a non-empty free-text answer when the
 * "Something else…" option is selected.
 */
function isValid(answers) {
  if (answers.decisions.length === 0) {
    return false;
  }
  const hasOtherSelected = answers.decisions.includes(OTHER_VALUE);
  return !hasOtherSelected || answers.decisionOther.trim().length > 0;
}

/** Multi-select "what are you trying to decide" step with a required "other" field. */
function AnalyticsFeedbackStep1Content(t0) {
  const $ = _c(15);
  const {
    answers,
    onAnswersChange
  } = t0;
  let t1;
  if ($[0] !== answers.decisions) {
    t1 = answers.decisions.includes(OTHER_VALUE);
    $[0] = answers.decisions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowOther = t1;
  let t2;
  if ($[2] !== answers.decisions || $[3] !== onAnswersChange) {
    t2 = function toggleDecision(value) {
      const decisions = answers.decisions.includes(value) ? answers.decisions.filter(current => current !== value) : [...answers.decisions, value];
      onAnswersChange({
        decisions
      });
    };
    $[2] = answers.decisions;
    $[3] = onAnswersChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleDecision = t2;
  let t3;
  if ($[5] !== answers.decisions || $[6] !== toggleDecision) {
    t3 = <AnalyticsFeedbackOptionList options={DECISIONS_OPTIONS} selectedValues={answers.decisions} isMultiSelect={true} onToggle={toggleDecision} />;
    $[5] = answers.decisions;
    $[6] = toggleDecision;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== answers.decisionOther || $[9] !== onAnswersChange || $[10] !== shouldShowOther) {
    t4 = shouldShowOther && <TextField fullWidth={true} placeholder={"Tell us\u2026"} text={answers.decisionOther} onTextChanged={decisionOther => onAnswersChange({
      decisionOther
    })} />;
    $[8] = answers.decisionOther;
    $[9] = onAnswersChange;
    $[10] = shouldShowOther;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <AnalyticsFeedbackStepLayout title="When you open analytics, what are you usually trying to decide?" subtext="Select all that apply.">{t3}{t4}</AnalyticsFeedbackStepLayout>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep1 = {
  stepName: "decisions",
  StepComponent: AnalyticsFeedbackStep1Content,
  isValid
};